import { LIONS_STICKY_MT } from '../experimentsEnum';
import { inExperiment } from '..';

export default (abTests) => inExperiment(LIONS_STICKY_MT, abTests);
